import {ModuleWithProviders} from '@angular/core';
import {RouterModule} from '@angular/router';
import {LoginComponent} from '../../components/login/login.component';
import {LoginModule} from '../modules/login.module';
import {BRANDS} from '../../../luxengine-brand-kit/brands';
import {LUXENGINE_LOGO_ON_LIGHT} from '../../services/brand.service';

const loginRoutes = [
    {
        path: '',
        component: LoginComponent,
        data: {brand: 'luxengine', logo: LUXENGINE_LOGO_ON_LIGHT, alt: BRANDS.luxengine.displayName, resetRoute: ['/setup', 'passwordreset']}
    },
    {
        path: 'bwrm',
        component: LoginComponent,
        data: {brand: 'bwrm', logo: 'assets/images/bwrm-new-logo.png', alt: 'BWRM', resetRoute: ['/setup', 'passwordreset', 'bwrm']}
    }
];

export const LoginRouting: ModuleWithProviders<LoginModule> = RouterModule.forChild(loginRoutes);
